export const maskPlate = (plate) =>
  String(plate)
    .replace(/([a-z]{3})(\d{1})([a-z\d]{1})(\d{2})/gi, '$1-$2$3$4')
    .toUpperCase()

export const maskPhone = (phone) =>
  String(phone)
    .replace(/[^\d*]/g, '')
    .replace(/^(.{2})(.{5}|.{4})(.{4})/g, '($1) $2-$3')

export const maskDocument = (doc) => {
  const [pattern, mask] =
    String(doc).length > 11
      ? [/^(.{2})(.{3})(.{3})(.{4})(.{2})/g, '$1.$2.$3/$4-$5']
      : [/^(.{3})(.{3})(.{3})(.{2})/g, '$1.$2.$3-$4']

  return String(doc)
    .replace(/[^\d*]/g, '')
    .replace(pattern, mask)
}

export const maskBankAccount = (account) => {
  return ' Ag ' + account?.agency + ' / C ' + account?.account + ' ' + account?.account_digit ?? ''
}

export const abbreviateName = (name, uppercase) => {
  name = String(name || '')
  name = uppercase ? name.toUpperCase() : name

  return name.split(' ').reduce((shortenName, word, index, words) => {
    const isFirstName = index === 0
    const isLastName = index === words.length - 1
    const shouldAbbreviate = !isFirstName && !isLastName && word.length > 3

    shortenName += shouldAbbreviate ? `${word.charAt(0).toUpperCase()} ` : `${word} `

    return shortenName
  }, '')
}

export const isEmptyValue = (value) => ['', undefined, null, '0,0'].includes(value)

export const isEmail = (email) =>
  String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
